import React, { Component, PropTypes } from 'react';
import ReactDOM from 'react-dom';
import Tooltip from 'Cio/Tooltip';

const css = oxygenCss({
  root: {
    position: 'relative',
    display: 'inline-block'
  }
});

class TooltipContainer extends Component {
  static propTypes = {
    children: PropTypes.node,
    tooltip: PropTypes.node
  };

  state = {
    hover: false,
    active: false
  };

  handleMouseEnter = () => {
    this.setState({ hover: true });
  };

  handleTouchTap = () => {
    this.setState({ hover: !this.state.hover });
  };

  handleMouseLeave = () => {
    this.setState({ hover: false });
  };

  handleFocus = () => {
    this.setState({ active: true });
  };

  handleBlur = () => {
    this.setState({ active: false });
  };

  getNode = () => {
    return ReactDOM.findDOMNode(this);
  };

  render() {
    const handlers = {
      onFocus: this.handleFocus,
      onBlur: this.handleBlur,
      onMouseEnter: this.handleMouseEnter,
      onMouseLeave: this.handleMouseLeave,
      onTouchTap: this.handleTouchTap
    };
    const { hover, active } = this.state;
    const { tooltip, children, ...other } = this.props;
    return (
      <div className={css.root} {...handlers} tabIndex={0}>
        {children}
        {(hover || active) &&
          tooltip && (
            <Tooltip anchorTo={this.getNode} {...other}>
              {tooltip}
            </Tooltip>
          )}
      </div>
    );
  }
}

export default TooltipContainer;



// WEBPACK FOOTER //
// ./src/js/Cio/TooltipContainer.js